var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91 12.97L8.625 1.86a.725.725 0 00-1.25 0L1.09 12.97A.695.695 0 001.715 14h12.57a.694.694 0 00.625-1.03zM2.22 13L8 2.784l5.78 10.214H2.22z",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.001 12a.93.93 0 01-.68-.275.94.94 0 010-1.35.946.946 0 01.68-.27.965.965 0 01.685.27.94.94 0 010 1.35.944.944 0 01-.685.275zm-.63-2.645L7.271 5h1.5l-.12 4.355h-1.28z",
    fill: "#6D6D6D"
  })));
}

export default SvgIconWarning;